import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ZoneBlacklistFormType } from './zone-blacklist-form-type';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { YesNoGroupButtonComponent } from 'src/app/base/shared/yes-no-group-button/yes-no-group-button.component';
import { MapBoxMapComponent, MapBoxMode, MapData } from 'src/app/base/shared/map-box-map/map-box-map.component';


@Component({
    selector: 'app-zone-details-blacklist',
    templateUrl: './zone-details-blacklist.component.html',
    styleUrls: ['./zone-details-blacklist.component.scss'],
    imports: [
        TranslateModule,
        ReactiveFormsModule,
        YesNoGroupButtonComponent,
        MapBoxMapComponent
    ]
})

export class ZoneDetailsBlacklistComponent implements OnInit, OnChanges {
  @ViewChild(MapBoxMapComponent) map: MapBoxMapComponent;

  @Input() useBlacklistArea: boolean;
  @Input() blacklistArea: string;
  @Output() dataChange = new EventEmitter<{ useBlacklistArea: boolean, blacklistArea: string }>();

  public blacklistForm: FormGroup<ZoneBlacklistFormType>;
  public hasGpsAreaChanged = false;

  public get mapData(): MapData {
    return {
      mode: MapBoxMode.GpsAreaMode,
      data: this.blacklistForm.controls.blacklistGPSArea.value
    };
  }

  public set mapData(value: MapData) {
    this.blacklistForm.controls.blacklistGPSArea.setValue(value?.data);
    const origGpsArea = this.blacklistForm.controls.blacklistGPSArea.value ? this.blacklistForm.controls.blacklistGPSArea.value : '';
    this.hasGpsAreaChanged = origGpsArea.localeCompare(value?.data) !== 0;
  }

  constructor(
    private fb: FormBuilder,
  ) { }

  ngOnInit() {
    this.createForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['useBlacklistArea']) {
      this.blacklistForm?.controls?.useBlacklistArea?.setValue(changes['useBlacklistArea'].currentValue);
    }
    if (changes['blacklistArea']) {
      this.blacklistForm?.controls?.blacklistGPSArea?.setValue(changes['blacklistArea'].currentValue);
    }
  }

  public lockMap(): void {
    this.map?.lockMap();
  }

  private createForm(): void {
    this.blacklistForm = this.fb.group<ZoneBlacklistFormType>({
      useBlacklistArea: this.fb.control<boolean>(this.useBlacklistArea),
      blacklistGPSArea: this.fb.control<string>(this.blacklistArea)
    });

    this.blacklistForm.valueChanges.subscribe((value) => {
      this.dataChange.emit({ useBlacklistArea: this.blacklistForm.controls.useBlacklistArea.value, blacklistArea: this.blacklistForm.controls.blacklistGPSArea.value });
    });
  }
}
